import React from 'react';
import { useScrollProgress } from '../hooks/useScrollProgress';
export function ProgressBar() {
  const progress = useScrollProgress();
  return <div className="fixed top-[40px] left-0 w-full h-[3px] bg-transparent z-[999]" data-id="element-185">
      <div className="h-full bg-gradient-to-r from-primary to-primary-light transition-all duration-100 ease-out" style={{
      width: `${progress}%`
    }} data-id="element-186" />
    </div>;
}